// =============================================
// THE ARCHIVE — Shopify Theme JS
// =============================================

// Countdown Timer
(function() {
  const el = document.querySelector('[data-countdown]');
  if (!el) return;

  const target = new Date(el.dataset.countdown);

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    const diff = Math.max(0, target - new Date());
    document.getElementById('cd-days').textContent    = pad(Math.floor(diff / 86400000));
    document.getElementById('cd-hours').textContent   = pad(Math.floor((diff % 86400000) / 3600000));
    document.getElementById('cd-minutes').textContent = pad(Math.floor((diff % 3600000) / 60000));
    document.getElementById('cd-seconds').textContent = pad(Math.floor((diff % 60000) / 1000));
  }

  tick();
  setInterval(tick, 1000);
})();

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(function(link) {
  link.addEventListener('click', function(e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// Product Gallery — thumbnail switching
(function() {
  const gallery = document.getElementById('ProductGallery');
  if (!gallery) return;
  const slides = gallery.querySelectorAll('.product-gallery__slide');
  const thumbs = gallery.querySelectorAll('.product-gallery__thumb');

  function goTo(index) {
    slides.forEach(function(s) { s.classList.remove('active'); });
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    if (slides[index]) slides[index].classList.add('active');
    if (thumbs[index]) thumbs[index].classList.add('active');
  }

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      goTo(parseInt(this.dataset.target, 10));
    });
  });
})();

// Product Page — variant selector
(function() {
  const form = document.getElementById('ProductForm');
  if (!form) return;

  document.querySelectorAll('.size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const siblings = document.querySelectorAll('.size-btn[data-option-name="' + this.dataset.optionName + '"]');
      siblings.forEach(function(s) { s.classList.remove('active'); });
      this.classList.add('active');
    });
  });
})();

// Cart — quantity update + remove via AJAX
(function() {
  function updateCart(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var subtotalEl = document.getElementById('CartSubtotal');
      if (subtotalEl) {
        subtotalEl.textContent = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency });
      }
      if (qty === 0) {
        var item = document.getElementById('CartItem-' + key);
        if (item) item.remove();
      } else {
        var qtyEl = document.querySelector('#CartItem-' + key + ' .qty-value');
        if (qtyEl) qtyEl.textContent = qty;
      }
    });
  }

  document.querySelectorAll('.qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var key = this.dataset.key;
      var qtyEl = document.querySelector('#CartItem-' + key + ' .qty-value');
      var current = parseInt(qtyEl ? qtyEl.textContent : 1, 10);
      var next = this.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
      updateCart(key, next);
    });
  });

  document.querySelectorAll('.cart-item__remove').forEach(function(btn) {
    btn.addEventListener('click', function() {
      updateCart(this.dataset.key, 0);
    });
  });
})();